import React from 'react';
import { motion } from 'framer-motion';
import { RecoveryButton } from './RecoveryButton';
interface FinalCTAProps {
  onEstimate: () => void;
}
export function FinalCTA({
  onEstimate
}: FinalCTAProps) {
  return <section className="mx-auto max-w-6xl px-5 py-20 sm:px-8 lg:py-24" data-id="element-746" data-mp="c7tvnlnquuuk">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-80px'
    }} transition={{
      duration: 0.6
    }} className="relative overflow-hidden rounded-3xl bg-forest px-6 py-14 text-center text-cream sm:px-12 sm:py-20" data-id="element-747" data-mp="85fct1k2rv3a">
        <div className="pointer-events-none absolute inset-0 opacity-[0.08]" style={{
        backgroundImage: 'radial-gradient(circle at 1px 1px, #F7F4EC 1px, transparent 0)',
        backgroundSize: '22px 22px'
      }} aria-hidden="true" data-id="element-748" data-mp="vv1d5sc6ogcv" />
        <div className="relative" data-id="element-749" data-mp="zxeg68zjq05y">
          <h2 className="mx-auto max-w-2xl font-display text-3xl font-medium leading-tight tracking-tight sm:text-4xl" data-id="element-750" data-mp="zua64uzega7d">
            Find out how much your excess and returned inventory is worth.
          </h2>
          <p className="mx-auto mt-4 max-w-lg text-cream/75" data-id="element-751" data-mp="2h5kmxwdx9xm6">
            Get a directional recovery estimate in 60 seconds — then a detailed report from our team.
          </p>
          <RecoveryButton onClick={onEstimate} starTone="forest" className="mt-8 rounded-full bg-cream px-8 py-4 text-base font-semibold text-forest transition-colors hover:bg-white" data-id="element-752" data-mp="2r38jmrv39f6z" />
        </div>
      </motion.div>
    </section>;
}